/**
 * Created by hp on 2017/8/9.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import { isLZWKAPP } from '../../utils'
import { toLecture, toChannel } from '../../utils/connectApp'
import {Panel, PanelBody, MediaBox, MediaBoxHeader, MediaBoxBody, MediaBoxTitle, MediaBoxDescription} from 'react-weui';
import {WKShowMore} from '../../components/wk';
import Running from '../../images/main/index_running_lecture.png'


class Item extends Component {

    renderPrice() {
        const {content} = this.props;
        if (content.need_money){
            if (content.has_limitmoney){
                if (Number(content.limit_money) === 0){
                    return <p><span>限时免费</span></p>
                }else {
                    return <p>￥{content.limit_money.split('.')[0]}<span>.{content.limit_money.split('.')[1]}</span></p>
                }
            }else {
                return <p>￥{content.lecture_money.split('.')[0]}<span>.{content.lecture_money.split('.')[1]}</span></p>
            }
        }else {
            return null
        }
    }

    render() {
        const {content} = this.props;

        return (
            <a className="wk-currency-item currency-item-border-top" href={content.url}>
                <div className="currency-item-left">
                    <div className="currency-item-img background-image" style={{backgroundImage: `url(${content.cover})`}}>
                    </div>
                </div>
                <div className="currency-item-right">
                    <div className="currency-item-right-title">
                        {content.name}
                    </div>
                    <div className="currency-item-right__container">
                        {content.start_name === '正在直播' &&
                        <div className="currency-item-right-mid">
                            <div className="currency-item-right-mid__running">
                                <img src={Running} alt=""/>
                                正在直播
                            </div>
                        </div>
                        }
                        <div className="currency-item-right-bottom">
                            <div className="currency-item-right-bottom_left">
                                <div className="currency-item-right-bottom_left-count">
                                    <span>{content.popular >= 10000 ? (content.popular / 10000).toFixed(2) + '万' : content.popular}</span>人气
                                </div>
                            </div>
                            <div className="currency-item-right-bottom_right">
                                {this.renderPrice()}
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        )
    }
}


class MainLivingLecture extends Component {
    constructor() {
        super();
        this.handleMoreLiving = this.handleMoreLiving.bind(this);
    }

    handleMoreLiving() {
        const {livingPage} = this.props;
        this.context.mainPage.loadLivingData(livingPage);
        window._czc && window._czc.push(["_trackEvent", 'common', 'click', 'main_living_btn_click', 1])
        this.props.dispatch({type: 'MAIN_NEXT_LIVING_PAGE'});
    }

    render() {
        const {livingLectures, hasMore} = this.props;

        if (livingLectures.length === 0) {
            return null;
        }

        const isShowShuangqian = this.props.isShowShuangqian
        return (
            <div className={`main-living-lecture ${isShowShuangqian ? '' : 'wk-mt-10'}`}>
                <Panel>
                    <PanelBody>
                        {livingLectures.map((v) => (
                            <Item content={v} key={v.id}/>
                        ))}
                    </PanelBody>
                </Panel>

                <div className={isShowShuangqian ? 'margin-bottom' : ''}>
                    <WKShowMore loading={hasMore} autoLoad={false} clickHandle={this.handleMoreLiving}/>
                </div>
            </div>
        )
    }
}

MainLivingLecture.contextTypes = {
    mainPage: React.PropTypes.object
};

export default connect((state) => ({
    livingPage: state.main.livingPage,
    livingLectures: state.main.starting.data.ret,
    hasMore: state.main.starting.data.has_more,
    isShowShuangqian: state.main.isShowShuangqian,
}))(MainLivingLecture)


// WEBPACK FOOTER //
// ./src/components/main/MainLivingLecture.js